var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row sessies-page" }, [
    _c("div", { staticClass: "col-12 col-md-6 sessies" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 mb-2", on: { click: _vm.handleNew } },
            [
              _c("div", { staticClass: "card new" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("h4", { staticClass: "mb-0" }, [
                        _c("span", { staticClass: "icon icon-circle" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "10",
                                height: "12",
                                viewBox: "0 0 10 12",
                                xmlns: "http://www.w3.org/2000/svg"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M9.28571 4.875H6.07143V1.5C6.07143 1.08586 5.75156 0.75 5.35714 0.75H4.64286C4.24844 0.75 3.92857 1.08586 3.92857 1.5V4.875H0.714286C0.319866 4.875 0 5.21086 0 5.625V6.375C0 6.78914 0.319866 7.125 0.714286 7.125H3.92857V10.5C3.92857 10.9141 4.24844 11.25 4.64286 11.25H5.35714C5.75156 11.25 6.07143 10.9141 6.07143 10.5V7.125H9.28571C9.68013 7.125 10 6.78914 10 6.375V5.625C10 5.21086 9.68013 4.875 9.28571 4.875Z"
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(
                          "\n                  Nieuwe tafelsessie toevoegen\n                "
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.sessies, function(sessie) {
            return _c("div", { key: sessie.id, staticClass: "col-12 mb-3" }, [
              _c(
                "div",
                {
                  staticClass: "card",
                  class: { active: _vm.selected_id === sessie.id },
                  on: {
                    click: function($event) {
                      return _vm.handleSelect(sessie.id)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("h4", { staticClass: "mb-0" }, [
                          _vm._v(_vm._s(sessie.title))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-auto" }, [
                        _c("div", { staticClass: "row" }, [
                          sessie.type
                            ? _c("div", { staticClass: "col-auto" }, [
                                sessie.type === "individueel"
                                  ? _c("span", [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-user text-primary mr-1",
                                        attrs: { "aria-hidden": "true" }
                                      }),
                                      _vm._v(" Open inschrijving")
                                    ])
                                  : sessie.type === "groepssessie"
                                  ? _c("span", [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-users text-primary mr-1",
                                        attrs: { "aria-hidden": "true" }
                                      }),
                                      _vm._v(" Teamtraining")
                                    ])
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-auto" }, [
                            _c("i", {
                              staticClass: "fa fa-money text-primary mr-1",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(
                              "\n                    € " +
                                _vm._s(sessie.price) +
                                "\n                  "
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ])
          }),
          _vm._v(" "),
          _vm.max_num_pages > 1
            ? _c("div", { staticClass: "col-12 mb-2" }, [
                _c(
                  "nav",
                  { attrs: { "aria-label": "Page navigation example" } },
                  [
                    _c(
                      "ul",
                      { staticClass: "pagination" },
                      [
                        _vm.page > 1
                          ? _c("li", { staticClass: "page-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  attrs: { "aria-label": "Vorige" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handlePagination("prev")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { "aria-hidden": "true" } },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "7",
                                            height: "10",
                                            viewBox: "0 0 7 10",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M4.96976 9.2793L6.03026 8.2188L2.81051 4.99905L6.03026 1.7793L4.96976 0.718797L0.689514 4.99905L4.96976 9.2793Z",
                                              fill: "#21386E"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Vorige")
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.max_num_pages, function(n) {
                          return _c(
                            "li",
                            {
                              key: n,
                              staticClass: "page-item",
                              class: { active: n == _vm.page }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  on: {
                                    click: function($event) {
                                      return _vm.handlePagination(n)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(n))]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.page < _vm.max_num_pages
                          ? _c("li", { staticClass: "page-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  attrs: { "aria-label": "Volgende" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handlePagination("next")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { "aria-hidden": "true" } },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "7",
                                            height: "10",
                                            viewBox: "0 0 7 10",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M2.03024 0.720703L0.969736 1.7812L4.18949 5.00095L0.969735 8.2207L2.03023 9.2812L6.31049 5.00095L2.03024 0.720703Z",
                                              fill: "#21386E"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Volgende")
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              ])
            : _vm._e()
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-md-6 sessie" },
      [
        _vm.new_sessie && !_vm.edit_sessie
          ? _c("new-sessie", {
              attrs: {
                expert: _vm.expert,
                ajax: _vm.ajax,
                handleSuccess: _vm.handleSuccess
              }
            })
          : !_vm.new_sessie && _vm.edit_sessie && _vm.selected_id
          ? _c("edit-sessie", {
              attrs: {
                expert: _vm.expert,
                ajax: _vm.ajax,
                id: _vm.selected_id,
                handleSuccess: _vm.handleSuccess,
                handleReturn: _vm.handleSelect
              }
            })
          : !_vm.new_sessie && !_vm.edit_sessie && _vm.selected_id
          ? _c("sessie", {
              attrs: {
                expert: _vm.expert,
                ajax: _vm.ajax,
                id: _vm.selected_id,
                handleEdit: _vm.handleEdit
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-2" }, [
      _c("div", { staticClass: "col" }, [_c("h2", [_vm._v("Trainingen")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col-auto" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-2" }, [
      _c("div", { staticClass: "card top" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("h3", { staticClass: "mb-0" }, [_vm._v("Titel")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/Sessies.vue?vue&type=template&id=f6bbd03e&
// module id = 346
// module chunks = 0